'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _modifiers = require('../../../modifiers');

var _modifiers2 = _interopRequireDefault(_modifiers);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var Checkbox = function Checkbox(_ref) {
  var className = _ref.className,
      style = _ref.style,
      disabled = _ref.disabled,
      value = _ref.value,
      children = _ref.children,
      checked = _ref.checked,
      name = _ref.name,
      allProps = _objectWithoutProperties(_ref, ['className', 'style', 'disabled', 'value', 'children', 'checked', 'name']);

  var props = _modifiers2.default.clean(allProps);

  return _react2.default.createElement('label', {
    disabled: disabled,
    className: (0, _classnames2.default)('checkbox', _modifiers2.default.classnames(allProps), className),
    style: style
  }, _react2.default.createElement('input', _extends({}, props, {
    name: name,
    type: 'checkbox',
    value: value,
    disabled: disabled,
    checked: checked
  })), children);
};

Checkbox.propTypes = _extends({}, _modifiers2.default.propTypes, {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  style: _propTypes2.default.shape({}),
  disabled: _propTypes2.default.bool,
  value: _propTypes2.default.string,
  checked: _propTypes2.default.bool,

  /**
   * The name of the input field Commonly used for [multi-input handling](https://reactjs.org/docs/forms.html#handling-multiple-inputs)
   */
  name: _propTypes2.default.string
});
Checkbox.defaultProps = _extends({}, _modifiers2.default.defaultProps, {
  children: null,
  className: '',
  value: '',
  style: {},
  disabled: false,
  checked: false,
  name: null
});
exports.default = Checkbox;